<template>
  <div class="texte texte-gris-fonce">
    {{ label }}
  </div>
</template>

<script>
export default {
  name: 'GraphLegendLabel',

  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>
